import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { AdminFeaturesService } from '../service/admin-features.service';

@Component({
  selector: 'app-subscribers-admin',
  templateUrl: './subscribers-admin.component.html',
  providers: [MessageService],
})
export class SubscribersAdminComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  rows: any[] = [];
  stats = { total: 0, active: 0, unsubscribed: 0 };
  page = 1;
  limit = 25;
  pages = 1;
  total = 0;
  q = '';
  status = 'all';
  loading = false;

  constructor(private svc: AdminFeaturesService, private toast: MessageService) {}

  ngOnInit() { this.load(); }

  load() {
    this.loading = true;
    this.svc.subscribers(this.q, this.status, this.page, this.limit)
      .pipe(takeUntil(this.destroy$))
      .subscribe((r: any) => {
        this.rows = r.data;
        this.stats = r.stats;
        this.total = r.pagination.total;
        this.pages = r.pagination.pages;
        this.loading = false;
      }, () => { this.loading = false; this.err('Failed to load subscribers'); });
  }

  search()            { this.page = 1; this.load(); }
  setStatus(s: string) { this.status = s; this.page = 1; this.load(); }
  go(p: number)       { if (p >= 1 && p <= this.pages) { this.page = p; this.load(); } }

  toggle(row: any) {
    const next = row.status === 'active' ? 'unsubscribed' : 'active';
    this.svc.setSubscriberStatus(row.id, next).pipe(takeUntil(this.destroy$)).subscribe(() => {
      row.status = next;
      this.ok(next === 'active' ? 'Re-subscribed' : 'Unsubscribed');
      this.refreshStats();
    }, () => this.err('Update failed'));
  }

  remove(row: any) {
    if (!confirm(`Permanently delete ${row.email}? This cannot be undone.`)) return;
    this.svc.deleteSubscriber(row.id).pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.ok('Subscriber deleted');
      this.load();
    }, () => this.err('Delete failed'));
  }

  private refreshStats() {
    this.svc.subscribers('', 'all', 1, 1).pipe(takeUntil(this.destroy$)).subscribe((r: any) => this.stats = r.stats);
  }

  exportCsv() { window.open(this.svc.subscriberExportUrl(this.status), '_blank'); }

  private ok(m: string)  { this.toast.add({ severity: 'success', summary: m }); }
  private err(m: string) { this.toast.add({ severity: 'error', summary: m }); }

  ngOnDestroy() { this.destroy$.next(); this.destroy$.complete(); }
}
